import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

import { DialogConstant } from '../Constant';

@Injectable({
    providedIn: 'root'
})
export class LoadingService
{
    private loader = null;
    private sync_loader = null;

    constructor(
        private loadingController: LoadingController
    )
    {
    }

    async presentLoading()
    {
        if (this.loader == null) {
            this.loader = await this.loadingController.create({
                message: DialogConstant.LOADING_MESSAGE,
                duration: 10000,
                mode: 'ios'
            });
            await this.loader.present();
        }
    }

    async proccessLoading()
    {
        if (this.loader == null) {
            this.loader = await this.loadingController.create({
                message: DialogConstant.PROCCESS_LOADING_MESSAGE,
                mode: 'ios'
            });
            await this.loader.present();
        }
    }

    closeLoading()
    {
        if (this.loader != null) {
            this.loader.dismiss();
            this.loader = null;
        }
    }
}
